import { primaryProperty } from "@api/businessService";
import { formatDate } from "./dates";

function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
};


function csvHeader (contentInfo)
{
    var csvArray = [];
    var $headers = Object.keys(contentInfo);

    for( var $e=0; $e < $headers.length; $e++) {
        csvArray.push($headers[$e]);
    }
    return csvArray;
}

function csvRow (contentInfo)
{
    var csvArray = [];
    var $headers = Object.keys(contentInfo);

    for(var $e=0; $e < $headers.length; $e++) {
        if (contentInfo[$headers[$e]] != null && contentInfo[$headers[$e]] != 'Invalid date') {
            csvArray.push(contentInfo[$headers[$e]]);
        } else {
            csvArray.push("");
        }
    }
    return csvArray;
}

function getInvolvements($objects)
{
    var $involvements = [];

    $objects.map(($object) => {
        if($object.involvements) {
            $object.involvements.map(($involvement) => {
                $involvements.push($involvement.name + " (" + ($involvement.pivot && $involvement.pivot.date != null ? $involvement.pivot.date : "No Date") + ")");
            })
        }
    });

    /*
    angular.forEach($objects, function($object)
    {
        if ($object.involvements) {
            angular.forEach($object.involvements, function($involvement)
            {
                $involvements.push($involvement.name + " (" + ($involvement.pivot && $involvement.pivot.date != null ? $involvement.pivot.date : "No Date") + ")");
            });
        }
    });
    */

    return $involvements.filter( onlyUnique );
};

export const handler = (labeledCommunities, communitySubdomain, results) => {
    var csvArray = [];

    let communityTitlePrefix = '';
    if(Object.keys(labeledCommunities).length > 1) {
        communityTitlePrefix = labeledCommunities[communitySubdomain] + ': ';
    }

    if (results.hasOwnProperty('contacts') && results.contacts.length > 0) {
        csvArray.push([communityTitlePrefix+'Contacts']);

        var $first = true;

        var $allInvolvements = getInvolvements(results.contacts);

        results.contacts.map(contact => {
            var contentInfo = {
                'Name': contact.name ? contact.name.trim() : (contact.company_name ? contact.company_name.trim() : `${contact?.first_name?.trim()} ${contact?.last_name?.trim()}`),
                'Email': contact.email,
                'OK to Contact': contact.do_not_contact ? 'No' : 'Yes',
                'First Name': contact?.first_name?.trim(),
                'Last Name': contact?.last_name?.trim(),
                'Company Name': contact?.company_name?.trim(),
                'Alternate Email': contact.alternate_email,
                'Address': contact.address,
                'Address 2': contact.address_2,
                'City': contact.city,
                'State': contact.state_province,
                'Zip': contact.zip_postal,
                'Country': contact.country,
                'Phone - Work': contact.work_phone,
                'Phone - Home': contact.home_phone,
                'Phone - Cell': contact.cell_phone,
                'Preferred Contact Method': contact.preferred_contact_method,
                'Birthday': contact.birthday,
                'Deceased Day': contact.deceased,
                'Notes': contact.notes,
                'Veteran': contact.is_veteran ? 'Yes' : 'No',
                'Minority': contact.is_minority ? 'Yes' : 'No',
                'Woman': contact.is_female ? 'Yes' : 'No',
                'LGBT': contact.is_lgbt ? 'Yes' : 'No',
                'Spouse': contact.spouse ? contact.spouse.name : '',
                // 'Website': contact.url,
                'Facebook': contact.facebook_url,
                'Twitter': contact.twitter_url,
                // 'Google Plus': contact.google_plus_url,
                'Instagram': contact.instagram_url,
                'LinkedIn': contact.linkedin_url,
                // 'Youtube': contact.youtube_url,
                // 'Yelp': contact.yelp_url,
            };

            var $involvements = {};

            if (contact.involvements) {
                contact.involvements.map($involvement =>
                {
                    var $currentInvolvement = $involvement.name + " (" + ($involvement.pivot && $involvement.pivot.date != null ? $involvement.pivot.date : "No Date") + ")";
                    $involvements[$currentInvolvement] = $involvement.pivot.notes;
                })
            }

            if ($allInvolvements) {
                $allInvolvements.map($involvement =>
                {
                    if ($involvements.hasOwnProperty($involvement)) {
                        contentInfo[$involvement] = 'Yes ' + ($involvements[$involvement] ? '('+$involvements[$involvement]+')' : '');
                    } else {
                        contentInfo[$involvement] = 'No';
                    }
                })
            }

            if ($first) {
                csvArray.push(csvHeader(contentInfo));
                $first = false;
            }

            csvArray.push(csvRow(contentInfo));
        });
        csvArray.push(['']);
    }

    if (results.hasOwnProperty('businesses') && results.businesses.length > 0) {

        csvArray.push([communityTitlePrefix+'Businesses']);
        $first = true;

        var $allInvolvements = getInvolvements(results.businesses);

        results.businesses.map(business =>
        {
            var $address = {
                address: null,
                address_2: null,
                city: null,
                state_province: null,
                zip_postal: null,
                country: null,
                longitude: null,
                latitude: null,
            };

            $address = (business.business_locations.length) ? primaryProperty(business.business_locations) : $address;

            var $hours = {
                sunday: {open: null, close: null, isClosed: 1},
                monday: {open: null, close: null, isClosed: 1},
                tuesday: {open: null, close: null, isClosed: 1},
                wednesday: {open: null, close: null, isClosed: 1},
                thursday: {open: null, close: null, isClosed: 1},
                friday: {open: null, close: null, isClosed: 1},
                saturday: {open: null, close: null, isClosed: 1},
            };

            for(var $i=0; $i < business.hours.length; $i++) {
                var $day = business.hours[$i];

                switch($day['day']) {
                    case 'Sunday':
                        $hours['sunday'] = {open: $day['open_time'], close: $day['close_time'], isClosed: $day['is_closed']};
                        break;
                    case 'Monday':
                        $hours['monday'] = {open: $day['open_time'], close: $day['close_time'], isClosed: $day['is_closed']};
                        break;
                    case 'Tuesday':
                        $hours['tuesday'] = {open: $day['open_time'], close: $day['close_time'], isClosed: $day['is_closed']};
                        break;
                    case 'Wednesday':
                        $hours['wednesday'] = {open: $day['open_time'], close: $day['close_time'], isClosed: $day['is_closed']};
                        break;
                    case 'Thursday':
                        $hours['thursday'] = {open: $day['open_time'], close: $day['close_time'], isClosed: $day['is_closed']};
                        break;
                    case 'Friday':
                        $hours['friday'] = {open: $day['open_time'], close: $day['close_time'], isClosed: $day['is_closed']};
                        break;
                    case 'Saturday':
                        $hours['saturday'] = {open: $day['open_time'], close: $day['close_time'], isClosed: $day['is_closed']};
                        break;
                }
            }

            var contentInfo = {
                'Primary Contact': business.primary_contact ? business.primary_contact.name.trim() : "",
                'Email': business.email,
                'OK to Contact': business.do_not_contact ? 'No' : 'Yes',
                'DBA Name': business?.dba_name?.trim(),
                'Type': typeof business.business_type !== 'undefined' && business.business_type !== null && business.business_type.hasOwnProperty('name') ? business.business_type.name : '',
                'Name': business.name.trim(),
                'Phone': business.phone,
                'Mailing Address': business.address_mail,
                'Mailing Address 2': business.address_2_mail,
                'Mailing City': business.city_mail,
                'Mailing State': business.state_province_mail,
                'Mailing Zip': business.zip_postal_mail,
                'Mailing Country': business.country_mail,
                'Longitude': $address.longitude,
                'Latitude': $address.latitude,
                'Address': $address.address,
                'Address 2': $address.address_2,
                'City': $address.city,
                'State': $address.state_province,
                'Zip': $address.zip_postal,
                'Country': $address.country,
                'In District?': business.not_in_district ? 'No' : 'Yes',
                'Membership': business.membership_level_name,
                'Website': business.url,
                'Facebook': business.facebook_url,
                'Twitter': business.twitter_url,
                'Google Plus': business.google_plus_url,
                'Instagram': business.instagram_url,
                'LinkedIn': business.linkedin_url,
                'Youtube': business.youtube_url,
                'Yelp': business.yelp_url,
                'Not for Profit': business.not_for_profit ? 'Yes' : 'No',
                'Tax ID': business.tax_id,
                'Employees - Full Time': business.full_time,
                'Employees - Part Time': business.part_time,
                'Employees - Seasonal': business.seasonal,
                'Opened On': formatDate(business.open_date),
                'Closed On': formatDate(business.close_date),
                'Relocated In': formatDate(business.moved_in_date),
                'Relocated Out': formatDate(business.moved_out_date),
                'Notes': business.notes,
                'Veteran-owned': business.is_veteran ? 'Yes' : 'No',
                'Minority-owned': business.is_minority ? 'Yes' : 'No',
                'Woman-owned': business.is_female ? 'Yes' : 'No',
                'LGBT-owned': business.is_lgbt ? 'Yes' : 'No',
                'Sunday Open': $hours['sunday']['open'],
                'Sunday Close': $hours['sunday']['close'],
                'Sunday Is Closed': $hours['sunday']['isClosed'],
                'Monday Open': $hours['monday']['open'],
                'Monday Close': $hours['monday']['close'],
                'Monday Is Closed': $hours['monday']['isClosed'],
                'Tuesday Open': $hours['tuesday']['open'],
                'Tuesday Close': $hours['tuesday']['close'],
                'Tuesday Is Closed': $hours['tuesday']['isClosed'],
                'Wednesday Open': $hours['wednesday']['open'],
                'Wednesday Close': $hours['wednesday']['close'],
                'Wednesday Is Closed': $hours['wednesday']['isClosed'],
                'Thursday Open': $hours['thursday']['open'],
                'Thursday Close': $hours['thursday']['close'],
                'Thursday Is Closed': $hours['thursday']['isClosed'],
                'Friday Open': $hours['friday']['open'],
                'Friday Close': $hours['friday']['close'],
                'Friday Is Closed': $hours['friday']['isClosed'],
                'Saturday Open': $hours['saturday']['open'],
                'Saturday Close': $hours['saturday']['close'],
                'Saturday Is Closed': $hours['saturday']['isClosed'],
                'Primary Contact Email': business.primary_contact ? business.primary_contact.email : "",
            };

            var $involvements = {};

            if (business.involvements) {
                business.involvements.map($involvement =>
                {
                    var $currentInvolvement = $involvement.name + " (" + ($involvement.pivot && $involvement.pivot.date != null ? $involvement.pivot.date : "No Date") + ")";
                    $involvements[$currentInvolvement] = $involvement.pivot.notes;
                })
            }

            if ($allInvolvements) {
                $allInvolvements.map($involvement =>
                {
                    if ($involvements.hasOwnProperty($involvement)) {
                        contentInfo[$involvement] = 'Yes ' + ($involvements[$involvement] ? '('+$involvements[$involvement]+')' : '');
                    } else {
                        contentInfo[$involvement] = 'No';
                    }
                })
            }

            if ($first) {
                csvArray.push(csvHeader(contentInfo));
                $first = false;
            }

            csvArray.push(csvRow(contentInfo));
        });
        csvArray.push(['']);
    }

    if (results.hasOwnProperty('properties') && results.properties.length > 0) {

        csvArray.push([communityTitlePrefix+'Properties']);
        $first = true;

        var $allInvolvements = getInvolvements(results.properties);

        var unitAttributes = [
            // 'address_2',
            'residential',
            'occupied',
            'square_footage',
            'rent',
            'num_residents',
        ];

        results.properties.map(property =>
        {
            // add default unit attributes to property
            for(var unitAttribute in unitAttributes)
            {
                property[unitAttribute] = '';
            }

            var propertyUnits = [property];

            // Property with units, add all of the units
            if(property.hasOwnProperty('property_units') && property.property_units.length)
            {
                for(var unitIterator in property.property_units)
                {
                    // set standard property values to empty strings
                    var unit = {};
                    for(var propertyKey in property)
                    {
                        unit[propertyKey] = '';
                    }

                    // reset address back
                    unit.address = property.address;
                    unit.address_2 = property.property_units[unitIterator].unit;
                    unit.unit_id = property.property_units[unitIterator].id;

                    // set unit information
                    for(var i in unitAttributes)
                    {
                        unit[unitAttributes[i]] = property.property_units[unitIterator][unitAttributes[i]];
                    }

                    // add unit
                    propertyUnits.push(unit);
                }
            }
            // No property units, just add the property
            else
            {
                propertyUnits = [property];
            }

            for(var unitIterator in propertyUnits)
            {
                var unit = propertyUnits[unitIterator];

                var businesses = '';

                if(property.hasOwnProperty('businesses') && property.businesses.length) {
                    for(var businessIterator in property.businesses) {
                        if (property.businesses[businessIterator].pivot.property_unit_id !== null) {
                            if (unit.unit_id === property.businesses[businessIterator].pivot.property_unit_id) {
                                if (businesses !== '') {
                                    businesses += ", ";
                                }

                                businesses += property.businesses[businessIterator].name;
                            }
                        } else {
                            if (unit.unit_id === undefined) {
                                if (businesses !== '') {
                                    businesses += ", ";
                                }

                                businesses += property.businesses[businessIterator].name;
                            }
                        }
                    }
                }

                var ownerInfo = {
                    owner: '',
                    address: '',
                    address2: '',
                    city: '',
                    state: '',
                    postal_code: '',
                    country: '',
                };

                if(unit.owner !== null) {
                    ownerInfo.owner = unit.owner.name;

                    if(unit.owner.hasOwnProperty('address_mail')) {
                        ownerInfo.address = unit.owner.address_mail;
                        ownerInfo.address2 = unit.owner.address_2_mail;
                        ownerInfo.city = unit.owner.city_mail;
                        ownerInfo.state = unit.owner.state_province_mail;
                        ownerInfo.postal_code = unit.owner.zip_postal_mail;
                        ownerInfo.country = unit.owner.country_mail;
                    } else {
                        ownerInfo.address = unit.owner.address;
                        ownerInfo.address2 = unit.owner.address_2;
                        ownerInfo.city = unit.owner.city;
                        ownerInfo.state = unit.owner.state;
                        ownerInfo.postal_code = unit.owner.zip_postal;
                        ownerInfo.country = unit.owner.country;
                    }
                }

                var contentInfo = {
                    'Owner': ownerInfo.owner,
                    'Address': unit.address,
                    'Address 2': unit.address_2,
                    'City': unit.city,
                    'State': unit.state_province,
                    'Zip': unit.zip_postal,
                    'Country': unit.country,

                    'Owner Mailing Address': ownerInfo.address,
                    'Owner Mailing Address 2': ownerInfo.address2,
                    'Owner Mailing City': ownerInfo.city,
                    'Owner Mailing State': ownerInfo.state,
                    'Owner Mailing Zip': ownerInfo.postal_code,
                    'Owner Mailing Country': ownerInfo.country,

                    'Latitude': unit.latitude,
                    'Longitude': unit.longitude,
                    'Type': typeof unit.land_use !== 'undefined' && unit.land_use !== null && unit.land_use.hasOwnProperty('name') ? unit.land_use.name : '',
                    'Parcel': unit.parcel_number,
                    'GIS Link': unit.gis_url,
                    'Square Footage': unit.square_footage,
                    'Floors': unit.floors,
                    'Residential Units': unit.residential_units ?? 0,
                    'Commercial Units': unit.commercial_units ?? 0,
                    'Assessed Market Value': unit.assessed_market_value,
                    'Is Residential': unit.residential == 1 ? 'Yes' : '',
                    'Is Occupied': unit.occupied == 1 ? 'Yes' : '',
                    'Rent': unit.rent,
                    'Number of Residents': unit.num_residents,
                    'TIF': unit.tif_name,
                    'SSA/BID': unit.ssa_name,
                    'Zoning': unit.zone_name,
                    'Enterprise Zone': (unitIterator === 0 ? (unit.enterprise ? 'Yes' : 'No') : ''),
                    'For Sale': (unitIterator === 0 ? (unit.for_sale ? 'Yes' : 'No') : ''),
                    'For Lease': (unitIterator === 0 ? (unit.for_lease ? 'Yes' : 'No') : ''),
                    'Private Parking': unit.private_parking,
                    'Architect': unit.architect,
                    'Built': formatDate(unit.built_date),
                    'Lost': formatDate(unit.lost_date),
                    'Reason Lost': unit.lost_reason,
                    'Notes': unit.notes,
                    'Veteran-owned': unit.is_veteran ? 'Yes' : 'No',
                    'Minority-owned': unit.is_minority ? 'Yes' : 'No',
                    'Woman-owned': unit.is_female ? 'Yes' : 'No',
                    'LGBT-owned': unit.is_lgbt ? 'Yes' : 'No',
                    'Businesses': businesses,
                };

                var $involvements = {};

                if (property.involvements) {
                    property.involvements.map($involvement =>
                    {
                        var $currentInvolvement = $involvement.name + " (" + ($involvement.pivot && $involvement.pivot.date != null ? $involvement.pivot.date : "No Date") + ")";
                        $involvements[$currentInvolvement] = $involvement.pivot.notes;
                    })
                }

                if ($allInvolvements) {
                    $allInvolvements.map($involvement =>
                    {
                        if ($involvements.hasOwnProperty($involvement)) {
                            contentInfo[$involvement] = 'Yes ' + ($involvements[$involvement] ? '('+$involvements[$involvement]+')' : '');
                        } else {
                            contentInfo[$involvement] = 'No';
                        }
                    })
                }

                if ($first) {
                    csvArray.push(csvHeader(contentInfo));
                    $first = false;
                }

                csvArray.push(csvRow(contentInfo));
            }

        });
        csvArray.push(['']);
    }

    const soldPropertiesAggregate = results?.aggregates?.sold_properties ?? null;

    if (
        soldPropertiesAggregate
        && Array.isArray(soldPropertiesAggregate.sales)
        && soldPropertiesAggregate.sales.length > 0
    ) {
        csvArray.push([communityTitlePrefix+'Property Sales']);
        $first = true;
        var soldProperties = soldPropertiesAggregate.properties ?? {};
        soldPropertiesAggregate.sales.map(sale =>
        {
            var soldProperty = soldProperties.hasOwnProperty(sale.property_id) ? soldProperties[sale.property_id] : null;

            var formerOwnerType = '';
            if (sale.former_owner_type === 'App\\Models\\Business') {
                formerOwnerType = 'Business';
            } else if (sale.former_owner_type) {
                formerOwnerType = 'Contact';
            }

            var contentInfo = {
                'Address': soldProperty ? soldProperty.address : '',
                'Sale Date': formatDate(sale.date),
                'Amount': sale.amount,
                'Former Owner': sale.former_owner ? sale.former_owner.name : '',
                'Former Owner Type': formerOwnerType,
                'Notes': sale.notes,
            };

            if ($first) {
                csvArray.push(csvHeader(contentInfo));
                $first = false;
            }

            csvArray.push(csvRow(contentInfo));
        });
        csvArray.push(['']);
    }

    if (results.hasOwnProperty('work-plans') && results['work-plans'].length > 0) {

        csvArray.push([communityTitlePrefix+'Work Plans']);
        $first = true;

        var $allInvolvements = getInvolvements(results['work-plans']);

        results['work-plans'].map(workplan =>
        {
            var contentInfo = {
                'Name': workplan.name,
                'Event Chair': workplan.event_chair ? workplan.event_chair.name : '',
                'Date': formatDate(workplan.workplan_date),
                'Description': workplan.description,
                'Notes': workplan.notes,
            };

            var $involvements = {};

            if (workplan.involvements) {
                workplan.involvements.map($involvement =>
                {
                    var $currentInvolvement = $involvement.name + " (" + ($involvement.pivot && $involvement.pivot.date != null ? $involvement.pivot.date : "No Date") + ")";
                    $involvements[$currentInvolvement] = $involvement.pivot.notes;
                })
            }

            if ($allInvolvements) {
                $allInvolvements.map($involvement =>
                {
                    if ($involvements.hasOwnProperty($involvement)) {
                        contentInfo[$involvement] = 'Yes ' + ($involvements[$involvement] ? '('+$involvements[$involvement]+')' : '');
                    } else {
                        contentInfo[$involvement] = 'No';
                    }
                })
            }

            if ($first) {
                csvArray.push(csvHeader(contentInfo));
                $first = false;
            }

            csvArray.push(csvRow(contentInfo));
        });
        csvArray.push(['']);
    }

    if (results.hasOwnProperty('workplan-tasks') && results['workplan-tasks'].length > 0) {
        csvArray.push([communityTitlePrefix+'Work Plans Tasks']);
        $first = true;

        results['workplan-tasks'].map(task =>
        {
            var contentInfo = {
                'Name': task.task_name,
                'Work Plan': task.workplan.name,
                'Due Date': formatDate(task.due_date),
                'Date Completed': '',
                'Assigned To': '',
            };

            if (task.completed_at) {
                contentInfo['Date Completed'] = formatDate(task.completed_at);
            }

            if (task.contacts.length > 0) {
                for (var $i=0; $i < task.contacts.length; $i++) {
                    contentInfo['Assigned To'] += $i == 0 ? '' : ', ';
                    contentInfo['Assigned To'] += task.contacts[$i]['name'];
                }
            }

            if ($first) {
                csvArray.push(csvHeader(contentInfo));
                $first = false;
            }

            csvArray.push(csvRow(contentInfo));
        });
        csvArray.push(['']);
    }

    if (results.hasOwnProperty('volunteer-hours') && results['volunteer-hours'].length > 0) {
        csvArray.push([communityTitlePrefix+'Volunteer']);

        var $first = true;

        results['volunteer-hours'].map(volunteer =>
        {
            var contentInfo = {
                'Name': volunteer.contact != null && volunteer.contact.hasOwnProperty('name') ? volunteer.contact.name : 'Removed',
                'Time (hours)': volunteer.time_taken,
                'Date': volunteer.volunteered_at,
                'Task': '',
                'Involvement': '',
                'Is Staff': volunteer.is_staff,
                'Notes': volunteer.notes,
            };

            if ($first) {
                csvArray.push(csvHeader(contentInfo));
                $first = false;
            }

            if (volunteer.task_info != null && volunteer.task_info.task_name != null) {
                contentInfo['Task'] = volunteer.task_info.task_name;
            }

            if (volunteer.involvement != null && volunteer.involvement.hasOwnProperty('name') != null) {
                contentInfo['Involvement'] = volunteer.involvement.name;
            }

            csvArray.push(csvRow(contentInfo));
        });
        csvArray.push(['']);
    }

    if (results.hasOwnProperty('donations') && results.donations.length > 0) {
        csvArray.push([communityTitlePrefix+'Donations']);

        var $first = true;

        results.donations.map(donation =>
        {
            let addrSuffix = '';
            if(donation.donation.donor_type.indexOf('Business') !== -1) {
                addrSuffix = '_mail';
            }

            var $address = {
                address: donation?.donation?.donor?.['address'+addrSuffix] ?? '',
                address_2: donation?.donation?.donor?.['address_2'+addrSuffix] ?? '',
                city: donation?.donation?.donor?.['city'+addrSuffix] ?? '',
                state_province: donation?.donation?.donor?.['state_province'+addrSuffix] ?? '',
                zip_postal: donation?.donation?.donor?.['zip_postal'+addrSuffix] ?? '',
                country: donation?.donation?.donor?.['country'+addrSuffix] ?? '',
            };

            // get business address from property if there's no mailing address
            if(
                donation.donation.donor != null
                && donation.donation.donor_type.indexOf('Business') !== -1
                &&
                (
                    typeof donation.donation.donor.address_mail != 'string'
                    || !donation.donation.donor.address_mail.trim().length
                )
                &&
                donation.donation.donor.business_locations.length > 0
            ) {
                $address = primaryProperty(donation.donation.donor.business_locations);
            }

            var contentInfo = {
                'Amount': donation.amount,
                'Type': donation.donation.type,
                'Frequency': donation.donation.frequency,
                'Invoice Number': donation.invoice_num,
                'Campaign': donation?.donation?.campaign?.name ?? '',
                'Fund': donation?.donation?.fund?.name ?? '',
                'Appeal': donation?.donation?.appeal?.name ?? '',
                'Donor': donation.donation.donor != null ? donation.donation.donor.name.trim() : "Removed",
                'Donation Date': donation.donation_date,
                'Received Date': donation.received,
                'Notes': donation.donation.notes,
                'Anonymous': donation.donation.anonymous ? 'Yes' : 'No',
                'Donor Address': $address.address,
                'Donor Address 2': $address.address_2,
                'Donor City': $address.city,
                'Donor State': $address.state_province,
                'Donor Zip': $address.zip_postal,
                'Donor Country': $address.country,
                'Donor Type': donation.donation.donor_type.indexOf('Business') !== -1 ? 'Business' : 'Contact',
            };

            if ($first) {
                csvArray.push(csvHeader(contentInfo));
                $first = false;
            }

            csvArray.push(csvRow(contentInfo));
        });
        csvArray.push(['']);
    }

    if (results.hasOwnProperty('volunteer-opportunities') && results['volunteer-opportunities'].length > 0) {
        csvArray.push([communityTitlePrefix+'Volunteer Opportunities']);

        var $first = true;

        results['volunteer-opportunities'].map(opportunity =>
        {
            var contentInfo = {
                'Name': opportunity.name,
                'Description': opportunity.description,
                'Event': opportunity.event ? opportunity.event.name : '',
                'Work Plan': opportunity.workplan ? opportunity.workplan.name : '',
                // 'Shift': '',
                // 'Job': '',
                // 'Sign Ups': '',
            };

            if ($first) {
                csvArray.push(csvHeader(contentInfo));
                $first = false;
            }

            csvArray.push(csvRow(contentInfo));
        });
        csvArray.push(['']);
    }

    return csvArray;
};
